import React from 'react';
import { IButton } from '../../../@types/button';
import { Retry } from './../../../common/icons/Retry';
import { Headline3 } from './../../../common/typography';
import { ButtonIcon } from './ButtonRetry.styled';

export function ButtonRetry ({ title, onClick }: IButton) {
  return (
    <ButtonIcon onClick={onClick}>
      <>
        <Retry />
        <Headline3 color="white">{title}</Headline3>
      </>
    </ButtonIcon>
  );
}
